var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTienda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7978 9.78L37.6977 3.04C37.2576 1.24 35.6975 0 33.8774 0H6.09586C4.29576 0 2.71567 1.26 2.29564 3.04L0.195523 9.78C-0.72453 13.72 1.89562 16 1.99563 16.12V32C1.99563 34.2 3.79573 36 5.99585 36H33.9974C36.1976 36 37.9977 34.2 37.9977 32V16.12C40.2378 13.88 40.1778 11.3 39.7978 9.78ZM21.9968 4H25.917L26.997 11.04C27.1771 12.46 26.217 14 24.4369 14C23.0968 14 21.9968 12.82 21.9968 11.38V4ZM8.87602 11.72C8.71601 13.02 7.67595 14 6.45588 14C4.59577 14 3.75573 12.06 4.07574 10.72L6.09586 4H10.0361L8.87602 11.72ZM17.9965 11.38C17.9965 12.82 16.8965 14 15.4164 14C13.9163 14 12.8162 12.6 12.9762 11.04L14.0763 4H17.9965V11.38ZM33.5374 14C32.3173 14 31.2573 13.02 31.1173 11.72L29.9572 4L33.8174 3.98L35.9175 10.72C36.2376 12.06 35.4175 14 33.5374 14Z",
    fill: "#7C8C52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTienda);
export default __webpack_public_path__ + "static/media/ic_tienda.3272747a34d498f86bb660795a77d0be.svg";
export { ForwardRef as ReactComponent };